module.exports = __webpack_public_path__ + "static/media/palmtree-big-2.7733838f.png";